module.exports = __webpack_public_path__ + "static/media/Tree.8c648b30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/Tree.svg
// module id = 13
// module chunks = 0